import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { LandlordBuildingDto } from "../../../../networking/data/responses/guestbuildings/LandlordBuildingDto";

export class LandlordData {
    public readonly avatarUrl: string;
    public readonly inGameName: string;

    public constructor(landlordDto: LandlordBuildingDto) {
        ObjectFieldsChecker.throwIfInvalidFields(landlordDto, ["avatarUrl", "inGameName"]);
        this.avatarUrl = landlordDto.avatarUrl;
        this.inGameName = landlordDto.inGameName;
    }
}
